<template>
  <div class="space-y-6">
    <h2 class="text-[30px] font-bold text-center text-primary-dark mb-4">
      Seu Mapa Numerológico Pitagórico está Pronto!
    </h2>

    <!-- Black Friday Offer -->
    <div class="bg-primary/10 border-l-4 border-primary p-4 mb-6 rounded-r-lg">
      <p class="font-bold text-primary-dark">Oferta Especial Black Friday! 🎉</p>
      <p class="text-gray-700">Acesso completo ao seu Mapa Numerológico:</p>
      <div class="text-center mt-4 space-y-2">
        <!-- Original Price -->
        <div class="text-gray-500">
          <span class="text-lg line-through">De R$197</span>
        </div>

        <!-- Sale Price -->
        <div>
          <p class="text-3xl font-bold text-primary-dark">
            Por apenas R$97
          </p>
          <p class="text-sm text-gray-600">
            ou 12x de R$9,74
          </p>
        </div>

        <!-- Savings Badge -->
        <div class="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
          Economia de R$100 (51% OFF)
        </div>

        <!-- CTA Button -->
        <a
          @click="handleCheckoutClick"
          class="cta-button green-glow mt-4 block w-full py-4 px-6 bg-green-500 text-white rounded-lg transition-all cursor-pointer font-semibold hover:bg-green-600 active:bg-green-700 active:scale-95"
        >
          <span class="flex items-center justify-center gap-2">
            <span>Garantir Minha Vaga Agora</span>
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </span>
        </a>
      </div>
    </div>

    <!-- Main Features -->
    <div class="space-y-6">
      <div class="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
        <h3 class="text-lg font-semibold text-primary-dark mb-2">
          O que você vai descobrir:
        </h3>

        <div class="space-y-4">
          <!-- Feature 1 -->
          <div class="flex items-start gap-3">
            <svg class="w-6 h-6 text-primary flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <p class="font-medium text-gray-800">Seu propósito de vida e missão única</p>
              <p class="text-sm text-gray-600">Descubra os caminhos ocultos que guiam sua jornada e aprenda a seguir a rota mais alinhada ao seu verdadeiro eu.</p>
            </div>
          </div>

          <!-- Feature 2 -->
          <div class="flex items-start gap-3">
            <svg class="w-6 h-6 text-primary flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <p class="font-medium text-gray-800">Seus talentos naturais</p>
              <p class="text-sm text-gray-600">Identifique e potencialize suas habilidades únicas para criar uma vida mais satisfatória em todas as áreas.</p>
            </div>
          </div>

          <!-- Feature 3 -->
          <div class="flex items-start gap-3">
            <svg class="w-6 h-6 text-primary flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <p class="font-medium text-gray-800">Acesso por 1 ano completo</p>
              <p class="text-sm text-gray-600">Um guia detalhado e personalizado que te acompanha em toda sua jornada de autoconhecimento.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Bonus Section -->
      <div class="bg-yellow-50 rounded-lg p-6 border border-yellow-100">
        <h3 class="text-lg font-semibold text-primary-dark mb-4 flex items-center gap-2">
          <span class="text-yellow-500">⭐</span>
          Bônus Exclusivos
        </h3>

        <div class="space-y-4">
          <!-- Bonus 1 -->
          <div class="flex items-start gap-3">
            <svg class="w-5 h-5 text-yellow-600 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <p class="font-medium text-gray-800">Relatório de Prosperidade Financeira</p>
              <p class="text-sm text-gray-600">Análise detalhada sobre manifestação de prosperidade e superação de desafios financeiros.</p>
            </div>
          </div>

          <!-- Bonus 2 -->
          <div class="flex items-start gap-3">
            <svg class="w-5 h-5 text-yellow-600 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <p class="font-medium text-gray-800">Orientação Prática Personalizada</p>
              <p class="text-sm text-gray-600">Aprenda a aplicar os insights do mapa no seu dia a dia para resultados reais.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Final CTA Button -->
    <a
      @click="handleCheckoutClick"
      class="cta-button purple-glow block w-full py-4 px-6 bg-gradient-to-r from-purple-600 to-primary text-white rounded-lg transition-all cursor-pointer font-semibold hover:from-purple-700 hover:to-primary-dark active:scale-95"
    >
      <span class="flex items-center justify-center gap-2">
        <span>Quero Meu Mapa Numerológico</span>
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
        </svg>
      </span>
    </a>

    <!-- Trust Badges -->
    <div class="space-y-4">
      <!-- Security Badge -->
      <div class="flex items-center justify-center gap-2 text-gray-600">
        <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
        </svg>
        <span class="text-sm">Pagamento 100% Seguro</span>
      </div>

      <!-- Satisfaction Guarantee -->
      <div class="text-center">
        <p class="text-sm text-gray-600">
          7 dias de garantia incondicional. Se você não ficar satisfeito(a),
          devolvemos 100% do seu dinheiro.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { trackCheckout } from '@/utils'
import { initializeGodOfWar } from '@/utils/services/godOfWar'

let isInitialized = false

const handleCheckoutClick = async () => {
  await trackCheckout()

  if (!isInitialized) {
    await initializeGodOfWar()
    isInitialized = true
  }

  if (typeof window.clickFn === 'function') {
    window.clickFn(1)
  } else {
    console.warn('God of War clickFn not available')
    const userId = localStorage.getItem('quiz_user_id')
    const baseUrl = 'https://pagamento.misteriosdodestino.com/p/mapa-numerologico-pitagorico-686U1EPP8'
    const checkoutUrl = userId
      ? `${baseUrl}?cupom=QUIZ&utm_source=quiz&utm_medium=quiz&utm_campaign=quiz&utm_id=${userId}`
      : `${baseUrl}?cupom=QUIZ`
    window.location.href = checkoutUrl
  }
}

onMounted(async () => {
  // Initialize God of War when FinalCTA mounts
  if (!isInitialized) {
    await initializeGodOfWar()
    isInitialized = true
  }
})
</script>

<style scoped>
.space-y-4 > * + * {
  margin-top: 1rem;
}

.space-y-6 > * + * {
  margin-top: 1.5rem;
}

.space-y-2 > * + * {
  margin-top: 0.5rem;
}

/* Button Animations */
.cta-button {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
  }
  70% {
    transform: scale(1.02);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

/* Button Glows */
.green-glow {
  box-shadow: 0 0 15px rgba(34, 197, 94, 0.4);
}

.purple-glow {
  box-shadow: 0 0 15px rgba(147, 51, 234, 0.4);
}

/* Hover Effects */
.cta-button:hover {
  transform: translateY(-2px);
  filter: brightness(1.1);
}

.cta-button:active {
  transform: translateY(0) scale(0.95);
  filter: brightness(0.95);
}
</style>